import { render, staticRenderFns } from "./MailActivate.vue?vue&type=template&id=1e96b01a&"
import script from "./MailActivate.vue?vue&type=script&lang=js&"
export * from "./MailActivate.vue?vue&type=script&lang=js&"
import style0 from "./MailActivate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports